<template>
    <small class="info--text" >{{ params.value | date }}</small>
</template>

<script>
    import Vue from 'vue';

    export default Vue.extend({
        
    });
</script>

<style >
</style>



// WEBPACK FOOTER //
// src/components/shared/DateFormatComponent.vue